@if (logo$ | async; as logo) {
  <a [href]="shopWebsite$ | async" aria-label="Shop Logo">
    <img class="logo" [src]="logo.url1x | plysResize: 200" alt="logo" />
  </a>
}
